import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input,
            UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Alert,
            Card, CardTitle, CardSubtitle, CardText, CardBody} from 'reactstrap';
import mfgFetch from "./mfg-fetch";

class ManufacturerContent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            content: {
                approvedContent: [],
                approvalContent: [],
                rejectedContent: [],
            },
            formInvalid: false,
            submitFailed: false,
            addDisabled: false,
            addModalState: false,
            deleteModalState: false,
            viewModalState: false,
            logModalState: false,
            editModalState: false,
            warningModalState: false,
            logContent: null,
            selectedContent: null,
            deleteContent: null,
            editContent: null,
            alertState: false,
            reapplyEdit: false,

            content_title: "",
            content_type: "video",
            content_description: "",
            content_category: "educational",
            content_range_start: null,
            content_range_end: null,
            content_file: null,
            content_thumbnail: null
        };

        this.handleContent = this.handleContent.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.toggleAddModal = this.toggleAddModal.bind(this);
        this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
        this.toggleViewModal = this.toggleViewModal.bind(this);
        this.toggleLogModal = this.toggleLogModal.bind(this);
        this.toggleEditModal = this.toggleEditModal.bind(this);
        this.toggleWarningModal = this.toggleWarningModal.bind(this);
        this.deleteContent = this.deleteContent.bind(this);
        this.publishContent = this.publishContent.bind(this);
        this.dismissAlert = this.dismissAlert.bind(this);
        this.handleEditSubmit = this.handleEditSubmit.bind(this);
    }

    componentWillMount() {
    }


    componentDidMount() {
        this.grabContent();
    }

    grabContent() {
        mfgFetch('/api/v1/mfg/content', {
            method: 'GET'
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                let body = await resp.json();
                this.handleContent(body);
            })
            .catch((err) => {
                console.error("Could not get manufacturer's content", err);
            });
    }

    selectContent(content) {
        this.setState({
            selectedContent: content,
            viewModalState: true,
        });
    }

    selectEdit(content) {
        if (!content) {
            return;
        }
        this.setState({
            editContent: content,
            content_title: content.content_title,
            content_type: content.content_type,
            content_description: content.content_description,
            content_category: content.content_category,
            content_range_start: content.content_range_start,
            content_range_end: content.content_range_end,
            editModalState: true,
        });
        if (content.content_approved === "1") {
            this.setState({
                warningModalState: true,
            });
        }
    }

    showApprovalLog(content) {
        this.setState({
            logContent: content,
            logModalState: true,
        });
    }

    handleContent(contents) {
        let approvedContent = [];
        let approvalContent = [];
        let rejectedContent = [];
        if (contents) {
            for (let content of contents) {
                if (content.hasOwnProperty('content_approved')) {

                    let published = null;
                    if (content.content_published === '1' && content.content_approved === '1') {
                        published = (
                            <DropdownItem onClick={(e) => this.publishContent(content.content_id, '0')}>Un-publish</DropdownItem>
                        );
                    } else if (content.content_approved === '1') {
                        published = (
                            <DropdownItem onClick={(e) => this.publishContent(content.content_id, '1')}>Publish</DropdownItem>
                        );
                    }

                    let rejected = null;
                    if (content.content_approved === '-1') {
                        rejected = (
                            <span>
                                <DropdownItem onClick={(e) => this.reapplyContent(content.content_id)}>Re-apply for approval</DropdownItem>
                                <DropdownItem onClick={(e) => this.showApprovalLog(content)}>Approval Log</DropdownItem>
                            </span>
                        );
                    }

                    let edit = (
                            <Button className="flex-fill content-edit-button" color="info" onClick={(e) => this.selectEdit(content)}>Edit</Button>
                    );

                    let deleteButton = (
                        <DropdownItem onClick={(e) => { this.setState({ deleteContent: content }); this.toggleDeleteModal(); }}>
                            Delete
                        </DropdownItem>
                    );

                    let viewDetails = (
                        <Button className="flex-fill content-view-button" color="primary" onClick={(e) => this.selectContent(content)}>View Details</Button>
                    );


                    let contentSubtitle = "";
                    switch (content.content_approved) {
                        case "-1":
                            contentSubtitle = "Approval denied";
                            break;
                        case "0":
                            contentSubtitle = "Awaiting approval";
                            break;
                        case "1":
                            if (content.content_published === "1") {
                                contentSubtitle = "Currently published";
                            } else {
                                contentSubtitle = "Currently un-published";
                            }
                            break;
                    }

                    let lastAction = new Date(content.content_uploaded);
                    if (content.content_updated) {
                        lastAction = new Date(content.content_updated);
                    }
                    let daysPending = (((new Date()).getTime() -  lastAction.getTime()) / 86400000);
                    let hoursPending = Math.floor((daysPending % 1) * 24);
                    let daysText = 'day';
                    if (daysPending >= 2) {
                        daysText = 'days';
                    }
                    let hoursText = 'hour';
                    if (hoursPending >= 2) {
                        hoursText = 'hours';
                    }

                    let contentPending = "";
                    let action = "Pending for";
                    if (content.content_approved === "1") {
                        if (content.content_published === "1") {
                            action = "Published for";
                        } else {
                            action = "";
                        }
                    }

                    if (action !== "") {
                        if (daysPending >= 1) {
                            contentPending = (
                                <p>{action} {daysPending.toFixed(0)} {daysText} and {hoursPending} {hoursText}</p>
                            );
                        } else if (hoursPending >= 1) {
                            contentPending = (
                                <p>{action} {hoursPending} {hoursText}</p>
                            );
                        } else {
                            contentPending = (
                                <p>{action} less than an hour</p>
                            );
                        }
                    }

                    if (content.content_approved === "-1") {
                        contentPending = (
                            <p>Denied on {lastAction.toLocaleString('en-us', {month: 'short'})} {lastAction.getDate()}, {lastAction.getFullYear()} </p>
                        );
                    }

                    let html = (
                        <Card>
                            <CardBody className="mfg-content-card">
                                <CardTitle><b>{content.content_title}</b></CardTitle>
                                <CardSubtitle>{contentSubtitle}</CardSubtitle>
                                <br />
                                <CardText>
                                    {contentPending}
                                </CardText>

                                <div className="d-flex flex-column p-1">
                                    <span className="d-flex flex-row justify-content-between p-1">
                                        {viewDetails}
                                        {edit}
                                        <span className="d-flex flex-row justify-content-end">
                                            <UncontrolledButtonDropdown direction="down">
                                                <DropdownToggle className="content-dropdown-button">⋮</DropdownToggle>
                                                <DropdownMenu>
                                                    {published}
                                                    {rejected}
                                                    {deleteButton}
                                                </DropdownMenu>
                                            </UncontrolledButtonDropdown>
                                        </span>
                                    </span>
                                </div>
                            </CardBody>
                        </Card>

                    );

                    content.html = html;

                    switch (content.content_approved) {
                        case "0":
                            approvalContent.push(content);
                            break;
                        case "1":
                            approvedContent.push(content);
                            break;
                        case "-1":
                            rejectedContent.push(content);
                            break;
                    }
                }
            }
        }

        this.setState({
            content: {
                approvedContent: approvedContent,
                approvalContent: approvalContent,
                rejectedContent: rejectedContent,
            }
        });
    }

    submitEditContent(e) {
        e.preventDefault();

        const data = new FormData(e.target);

        this.setState({
            formInvalid: false,
            submitFailed: false
        });

        if (!this.validateForm()) {
            this.setState({
                formInvalid: true
            });
            return;
        }

        mfgFetch('/api/v1/mfg/resubmit', {
            method: 'POST',
            body: data,
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                this.setState({
                    editModalState: false,
                    alertState: true,
                });
                this.grabContent();
                this.setAlertMessage("Your content was successfully edited.\n");
            })
            .catch((err) => {
                console.error('There was an error trying to edit your content: ', err);
                this.setState({
                    submitFailed: true
                });
            });
    }

    handleEditSubmit(e, id) {
        this.submitEditContent(e);
        if (this.state.reapplyEdit) {
            this.reapplyContent(id);
        }
    }

    saveAndReapply() {
        this.setState({
            reapplyEdit: true,
        });
    }

    submitContent(e) {
        e.preventDefault();
        const data = new FormData(e.target);

        this.setState({
            formInvalid: false,
            submitFailed: false,
            addDisabled: true,
        });

        if (!this.validateForm()) {
            this.setState({
                formInvalid: true,
                addDisabled: false,
            });
            return;
        }

        mfgFetch('/api/v1/mfg/content', {
            method: 'POST',
            body: data,
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                this.setState({
                    addModalState: false,
                    alertState: true,
                    addDisabled: false,
                });
                this.grabContent();
                this.setAlertMessage("Your content was successfully submitted. Please wait for one of our team members to review and process your content.\n");
            })
            .catch((err) => {
                console.error('Could not submit content: ', err);
                this.setState({
                    submitFailed: true,
                    addDisabled: false,
                });
            });

    }

    addContentClick(e) { // open add content window
        this.setState({
            addModalState: true,
            content_title: "",
            content_type: "video",
            content_description: "",
            content_category: "educational",
            content_range_start: null,
            content_range_end: null,
            content_file: null,
            content_thumbnail: null,
        });
    }

    toggleAddModal() { // toggle open content window
        this.setState(prevState => ({
            addModalState: !prevState.addModalState
        }));
    }

    toggleDeleteModal() { // toggle open content window
        this.setState(prevState => ({
            deleteModalState: !prevState.deleteModalState,
        }));
    }

    toggleViewModal() {
        this.setState(prevState => ({
            viewModalState: !prevState.viewModalState,
        }));
    }

    toggleLogModal() {
        this.setState(prevState => ({
            logModalState: !prevState.logModalState,
        }));
    }

    toggleEditModal() {
        this.setState(prevState => ({
            editModalState: !prevState.editModalState,
        }));
    }

    toggleWarningModal() {
        this.setState(prevState => ({
            warningModalState: !prevState.warningModalState,
        }));
    }


    validateForm() {
    // @TODO extra form validation
        return true;
    }

    handleChange(e) {
        if (e.target.name === 'content_file' || e.target.name === 'content_thumbnail') {
            this.setState({ [e.target.name]: e.target.files[0] });
            return;
        }
        this.setState({ [e.target.name]: e.target.value });
    }

    deleteContent(contentId) {
        mfgFetch('/api/v1/mfg/delete', {
            method: 'POST',
            body: JSON.stringify({
                content_id: contentId,
            }),
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                this.setAlertMessage("Successfully deleted content.");
                this.grabContent();
            })
            .catch((err) => {
                console.error('could not delete content: ', err);
                this.setAlertMessage("There was an error trying to delete that content.");
            });
            this.setState({
                deleteModalState: false
            });
    }

    publishContent(contentId, status) {
        mfgFetch('/api/v1/mfg/publish', {
            method: 'POST',
            body: JSON.stringify({
                content_id: contentId,
                content_published: status
            }),
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                let action = "published";
                if (status === '0') {
                    action = "un-published";
                }
                this.setAlertMessage("Successfully " + action + " content.");
                this.grabContent();
            })
            .catch((err) => {
                console.error('could not publish content: ', err);
                this.setAlertMessage("There was an error trying to modify that content.");
            });

    }

    reapplyContent(contentId) {
        mfgFetch('/api/v1/mfg/reapply', {
            method: 'POST',
            body: JSON.stringify({
                content_id: contentId,
            }),
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                this.setAlertMessage("Successfully re-submitted content for approval.");
                this.grabContent();
            })
            .catch((err) => {
                console.error('could not re-apply content: ', err);
                this.setAlertMessage("There was an error trying to re-submit that content for approval.");
            });
    }

    dismissAlert() {
        this.setState({
            alertState: false,
        });
    }

    setAlertMessage(msg) {
        this.setState({
            alertMessage: msg
        });
    }

    render() {
       let approvalContent = [];
       for(let content of this.state.content.approvalContent) {
           if (!content) {
               continue;
           }
           approvalContent.push(content.html);

       }
       // Add more content button
       approvalContent.push(
           <Card>
               <CardBody>
                   <div className="d-flex flex-row justify-content-center add-container p-1" onClick={(e) => this.addContentClick(e)}>
                       <span className="mfg-content-add my-auto">+</span>
                   </div>
               </CardBody>
           </Card>
       );

        let approvedContent = [];
        for(let content of this.state.content.approvedContent) {
            if (!content) {
                continue;
            }
            approvedContent.push(content.html);
        }

        let rejectedContent = [];
        for(let content of this.state.content.rejectedContent) {
            if (!content) {
                continue;
            }
            rejectedContent.push(content.html);
        }

        let approvalSection = (
            <div className="d-flex flex-column py-2">
                <h3 className="section-title">Awaiting Approval</h3>
                <div className="d-flex flex-row">
                    {approvalContent}
                </div>
            </div>
        );
        let approvedSection = (
            <div className="d-flex flex-column py-2">
                <h3 className="section-title">Approved Content</h3>
                <div className="d-flex flex-row">
                    {approvedContent}
                </div>
            </div>
        );
        let rejectedSection = (
            <div className="d-flex flex-column py-2">
                <h3 className="section-title">Rejected Content</h3>
                <div className="d-flex flex-row">
                    {rejectedContent}
                </div>
            </div>
        );

        let viewModal = null;
        if (this.state.selectedContent) {
            let locale = window.navigator.userLanguage || window.navigator.language || "en-US";
            let start = "";
            if (this.state.selectedContent.content_range_start) {
                start = (
                    <span><b>Start Date:</b> {(new Date(this.state.selectedContent.content_range_start)).toLocaleDateString(locale)}</span>
                );
            }
            let end = "";
            if (this.state.selectedContent.content_range_end) {
                end = (
                    <span><b>End Date:</b> {(new Date(this.state.selectedContent.content_range_end)).toLocaleDateString(locale)}</span>
                );
            }

            let uploaded = new Date(this.state.selectedContent.content_uploaded);
            let updated = new Date(this.state.selectedContent.content_updated);

            let daysPending = (((new Date()).getTime() -  updated.getTime()) / 86400000);
            let hoursPending = Math.floor((daysPending % 1) * 24);
            let daysText = 'day';
            if (daysPending >= 2) {
                daysText = 'days';
            }
            let hoursText = 'hour';
            if (hoursPending > 1) {
                hoursText = 'hours';
            }
            let pending = null;
            if (this.state.selectedContent.content_approved === '0') {
                if (daysPending >= 1) {
                    pending = (
                        <span><b>Pending for:</b> {daysPending.toFixed(0)} {daysText} and {hoursPending} {hoursText}</span>
                    );
                } else if (hoursPending >= 1) {
                    pending = (
                        <span><b>Pending for:</b> {hoursPending} {hoursText}</span>
                    );
                } else {
                    pending = (
                        <span><b>Pending for:</b> less than an hour</span>
                    );
                }
            }

            viewModal = (
                <Modal isOpen={this.state.viewModalState}>
                    <ModalHeader toggle={this.toggleViewModal}>{this.state.selectedContent.content_title}</ModalHeader>
                    <ModalBody>
                        <div className="d-flex flex-column">
                            <div className="d-flex flex-row justify-content-between">
                                <span className="content-stats d-flex flex-column">
                                    <p><b>Description:</b> {this.state.selectedContent.content_description}</p>
                                    <p><b>Type:</b> {this.state.selectedContent.content_type}</p>
                                    <p><b>Category:</b> {this.state.selectedContent.content_category}</p>
                                    {start}
                                    {end}
                                    <hr/>
                                    <span><b>Manufacturer:</b> {this.state.selectedContent.content_manufacturer_text}</span>
                                    <span><b>Uploaded:</b> {uploaded.toLocaleDateString("en-US")}</span>
                                    <span><b>Last Updated:</b> {updated.toLocaleDateString("en-US")}</span>
                                    {pending}
                                </span>
                                <span className="content-thumbnail my-auto">
                                    <span className="d-flex flex-column">
                                        <img  className="mx-auto" src={"/content/" + this.state.selectedContent.content_id + "_t"} alt="Content thumbnail" height="150px"/>
                                        <a href={"/content/" + this.state.selectedContent.content_id} target="_blank" className="mx-auto pt-2">View Content</a>
                                    </span>
                                </span>
                            </div>
                            <span className="d-flex flex-row justify-content-between p-1">
                                <Button className="mx-auto" onClick={(e) => this.toggleViewModal()}>Close</Button>
                            </span>
                        </div>
                    </ModalBody>
                </Modal>
            );
        }

        let deleteModal = null;
        if (this.state.deleteContent) {
            deleteModal = (
                <Modal isOpen={this.state.deleteModalState}>
                    <ModalHeader toggle={this.toggleDeleteModal}>Are you sure?</ModalHeader>
                    <ModalBody>
                        Please confirm that you would like to DELETE content titled: <b>{this.state.deleteContent.content_title}</b>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={(e) => this.deleteContent(this.state.deleteContent.content_id)}>Yes, delete</Button>
                        <Button color="info" onClick={(e) => this.toggleDeleteModal()}>No, go back</Button>
                    </ModalFooter>
                </Modal>
            );
        }

        let logModal = null;
        if (this.state.logContent) {
            let denials = [];
            for (let denial of this.state.logContent.content_denials) {
                let deniedDate = new Date(denial.denial_created);
                denials.push(
                    <Card body>
                        <CardTitle>Denied by {denial.denial_username} - {deniedDate.toLocaleString('en-us', {month: 'long'}) + '-' + deniedDate.getDate()}</CardTitle>
                        <CardText>Reasoning: {denial.denial_reason}</CardText>
                    </Card>
                );
            }
            logModal = (
                <Modal isOpen={this.state.logModalState}>
                    <ModalHeader toggle={this.toggleLogModal}>{this.state.logContent.content_title} - Approval Log</ModalHeader>
                    <ModalBody>
                        {denials}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="info" onClick={(e) => this.toggleLogModal()}>Close</Button>
                    </ModalFooter>
                </Modal>
            );
        }

        let addModal = (
            <Modal isOpen={this.state.addModalState}>
                <ModalHeader toggle={this.toggleAddModal}>Upload Content</ModalHeader>
                <Form onSubmit={(e) => this.submitContent(e)}>
                    <ModalBody>
                        <FormGroup className="d-flex flex-column p-2">
                            <p className="align-self-center">File uploads: Thumbnail must be a png or jpeg, under 5MB. Files must be under 1GB and can be a document/pdf or image (png, jpeg, gif).</p>
                            <span className="d-flex flex-row p-1">
                                <Label className="content-label pr-1">Content Title</Label>
                                <Input
                                    type="text"
                                    name="content_title"
                                    className="text-left"
                                    onChange={this.handleChange}
                                    required
                                    />
                            </span>
                            <span className="d-flex flex-row p-1">
                                <Label className="content-label pr-1">Content Type</Label>
                                <select name="content_type" onChange={this.handleChange}>
                                    <option value="document">PDF/Document</option>
                                    <option value="video">Video</option>
                                </select>
                            </span>

                            <span className="d-flex flex-row p-1">
                                <Label className="content-label pr-1">Description:</Label>
                                <textarea name="content_description" onChange={this.handleChange} rows="4" required />
                            </span>

                            <span className="d-flex flex-row p-1">
                                <Label className="content-label pr-1">Category:</Label>
                                <select name="content_category" onChange={this.handleChange}>
                                    <option value="educational">Educational</option>
                                    <option value="new">New Products</option>
                                    <option value="events">Events</option>
                                    <option value="misc">Miscellaneous</option>
                                </select>
                            </span>

                            <span className="d-flex flex-row p-1">
                                <Label className="content-label pr-1">
                                    Range start (optional):
                                </Label>
                                <Input
                                    type="date"
                                    name="content_range_start"
                                    onChange={this.handleChange}
                                    />
                            </span>

                            <span className="d-flex flex-row p-1">
                                <Label className="content-label pr-1">
                                    Range end (optional):
                                </Label>
                                <Input
                                    type="date"
                                    name="content_range_end"
                                    onChange={this.handleChange}
                                />
                            </span>

                            <span className="d-flex flex-row p-1">
                                <Label className="content-label pr-1">File:</Label>
                                <Input
                                    type="file"
                                    name="content_file"
                                    onChange={this.handleChange}
                                    required
                                />
                            </span>

                            <span className="d-flex flex-row p-1">
                                <Label className="content-label pr-1">Thumbnail: </Label>
                                <Input
                                    type="file"
                                    name="content_thumbnail"
                                    onChange={this.handleChange}
                                    required
                                />
                            </span>
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" disabled={this.state.addDisabled}>Submit Content</Button>
                        <Button color="secondary" onClick={(e) => this.toggleAddModal()}>Cancel</Button>
                    </ModalFooter>
                </Form>
            </Modal>
        );

        let warningModal = (
            <Modal isOpen={this.state.warningModalState}>
                <ModalHeader>Warning</ModalHeader>
                <ModalBody>
                    Editing a piece of content that is <b>already approved</b> will cause it to become un-approved and no longer able to be published. It will re-enter the awaiting for approval queue if edited.
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={(e) => this.setState({warningModalState: false})}>I understand</Button>
                </ModalFooter>
            </Modal>
        );

        let editModal = null;
        if (this.state.editContent) {

            let dateInputStart = new Date(this.state.content_range_start);
            let startInputValue = "";
            if (dateInputStart) {
                let tempDate = new Date(dateInputStart.getTime() - (dateInputStart.getTimezoneOffset() * 6000));
                if (!isNaN(tempDate)) {
                    startInputValue = tempDate.toISOString().split("T")[0];
                }
            }
            let dateInputEnd = new Date(this.state.content_range_end);
            let endInputValue = "";
            if (dateInputEnd) {
                let tempDate = new Date(dateInputEnd.getTime() - (dateInputEnd.getTimezoneOffset() * 6000));
                if (!isNaN(tempDate)) {
                    endInputValue = tempDate.toISOString().split("T")[0];
                }
            }
            editModal = (
                <Modal isOpen={this.state.editModalState}>
                    <ModalHeader toggle={this.toggleEditModal}>Edit Content</ModalHeader>
                    <Form onSubmit={(e) => this.handleEditSubmit(e, this.state.editContent.content_id)}>
                        <ModalBody>
                        <span className="content-thumbnail my-auto">
                            <span className="d-flex flex-column mx-auto">
                                <img className="mx-auto" src={"/content/" + this.state.editContent.content_id + "_t"} alt="Content thumbnail" height="150px"/>
                                <a href={"/content/" + this.state.editContent.content_id} target="_blank" className="mx-auto pt-2">View Content</a>
                            </span>
                        </span>
                            <FormGroup className="d-flex flex-column p-2">
                                <Input type="hidden" name="content_id" value={this.state.editContent.content_id} />
                                <span className="d-flex flex-row p-1">
                                    <Label className="content-label pr-1">Content Title</Label>
                                    <Input
                                        type="text"
                                        name="content_title"
                                        className="text-left"
                                        onChange={this.handleChange}
                                        value={this.state.content_title}
                                        required
                                    />
                                </span>
                                <span className="d-flex flex-row p-1">
                                    <Label className="content-label pr-1">Content Type</Label>
                                    <select name="content_type" onChange={this.handleChange} value={this.state.content_type}>
                                        <option value="video">Video</option>
                                        <option value="document">PDF/Document</option>
                                    </select>
                                </span>

                                <span className="d-flex flex-row p-1">
                                    <Label className="content-label pr-1">Description:</Label>
                                    <textarea name="content_description" onChange={this.handleChange} rows="4"
                                              required value={this.state.content_description} />
                                </span>

                                <span className="d-flex flex-row p-1">
                                    <Label className="content-label pr-1">Category:</Label>
                                    <select name="content_category" onChange={this.handleChange} value={this.state.content_category}>
                                        <option value="educational">Educational</option>
                                        <option value="new">New Products</option>
                                        <option value="events">Events</option>
                                        <option value="misc">Miscellaneous</option>
                                    </select>
                                </span>

                                <span className="d-flex flex-row p-1">
                                    <Label className="content-label pr-1">
                                        Range start (optional):
                                    </Label>
                                    <Input
                                        type="date"
                                        name="content_range_start"
                                        onChange={this.handleChange}
                                        value={startInputValue}
                                    />
                                </span>

                                <span className="d-flex flex-row p-1">
                                    <Label className="content-label pr-1">
                                        Range end (optional):
                                    </Label>
                                    <Input
                                        type="date"
                                        name="content_range_end"
                                        onChange={this.handleChange}
                                        value={endInputValue}
                                    />
                                </span>

                                <span className="d-flex flex-row p-1">
                                    <Label className="content-label pr-1">File:</Label>
                                    <Input
                                        type="file"
                                        name="content_file"
                                        onChange={this.handleChange}
                                    />
                                </span>

                                <span className="d-flex flex-row p-1">
                                    <Label className="content-label pr-1">Thumbnail:</Label>
                                    <Input
                                        type="file"
                                        name="content_thumbnail"
                                        onChange={this.handleChange}
                                    />
                                </span>
                            </FormGroup>
                        </ModalBody>
                        <ModalFooter>
                            <Button type="submit" color="primary">Save Draft</Button>
                            {this.state.editContent.content_approved === "-1" ? <Button type="submit" color="info" onClick={(e) => this.saveAndReapply()}>Save Draft & Reapply</Button> : ''}
                            <Button color="secondary" onClick={(e) => this.toggleEditModal()}>Cancel</Button>
                        </ModalFooter>
                    </Form>
                </Modal>
            );
        }

        return (
            <div className="d-flex flex-column">
                <span>
                    <Alert className="mx-auto m-1" color="success" isOpen={this.state.alertState} toggle={this.dismissAlert}>
                        {this.state.alertMessage}
                    </Alert>
                </span>
                {approvalSection}
                {approvedSection}
                {rejectedSection}

                {addModal}
                {editModal}
                {viewModal}
                {deleteModal}
                {logModal}
                {warningModal}
            </div>
        );
    }
}

export default ManufacturerContent;